Vue.filter("attachText", function(item, text)
{
    return text + item;
});
